import { render, staticRenderFns } from "./approval-non-defect-vehicle.vue?vue&type=template&id=4989225e&scoped=true&"
import script from "./approval-non-defect-vehicle.vue?vue&type=script&lang=js&"
export * from "./approval-non-defect-vehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4989225e",
  null
  
)

export default component.exports